"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_COLORS = exports.TOUCHPOINTS = void 0;
exports.TOUCHPOINTS = {
    UNIPOLSAI: "unipolsai",
    BIMVITA: "bim-vita",
    WHITELABEL: "whitelabel",
    APPHUB: "apphub",
};
exports.PAGE_COLORS = {
    BLUE: "blue",
    GREEN: "green",
    ORANGE: "orange",
};
